<div class="card shadow-sm rounded-4 border-0 mt-3" *ngIf="org">
  <div class="card-body p-4">
    <div *ngIf="loading" class="text-center py-4">
      <span class="spinner-border text-primary" role="status"></span>
    </div>
    <div *ngIf="error" class="alert alert-danger">A server error occured. Please try again later.</div>
    <ng-container *ngIf="!loading && !error && org">
      <div class="card-group gap-3">
        <!-- Organization Info -->
        <div class="card border-0 bg-light-subtle">
          <div class="card-body p-3">
            <h5 class="mb-3 text-primary">Organization Details</h5>
            <div class="org-details-fields">
              <div class="mb-3">
                <label class="form-label">Organization Name</label>
                <div class="form-control-plaintext">{{ org.name }}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Display Name</label>
                <div class="form-control-plaintext">{{ org.displayName }}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Ship To</label>
                <div class="form-control-plaintext">{{ org.shipTo }}</div>
              </div>
              <div class="mb-3">
                <label class="form-label">Sold To</label>
                <div class="form-control-plaintext">{{ org.soldTo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>